import { Trans } from "react-i18next";
import styles from "./footer.module.scss";
import { PRIVACY_POLICY, TERMS_OF_SERVICE } from "@/constants/external-routes";

const Footer = ({ className }) => {
  return (
    <footer
      className={`${styles.footer} ${className ? className : ""} flex center pt-8 pb-4 no-print`}
    >
      <div className="flex">
        <Trans
          i18nKey="privacyPolicyFooterMessage"
          components={{
            a1: (
              <span
                className="link ml-2 mr-2"
                onClick={() => window.open(PRIVACY_POLICY, "_blank")}
              ></span>
            ),
            a2: (
              <span
                className="link ml-2 mr-2"
                onClick={() => window.open(TERMS_OF_SERVICE, "_blank")}
              ></span>
            ),
            a3: (
              <span
                className="link ml-2"
                onClick={() =>
                  window.open("mailto:abstract@prophia.com", "_blank")
                }
              ></span>
            ),
          }}
        />
      </div>
    </footer>
  );
};

export default Footer;
